import { render, staticRenderFns } from "./manage-activity-list-item-action-buttons.component.vue?vue&type=template&id=356d8c9f&scoped=true&"
import script from "./manage-activity-list-item-action-buttons.component.vue?vue&type=script&lang=ts&"
export * from "./manage-activity-list-item-action-buttons.component.vue?vue&type=script&lang=ts&"
import style0 from "./manage-activity-list-item-action-buttons.component.vue?vue&type=style&index=0&id=356d8c9f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356d8c9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
